module.exports = __webpack_public_path__ + "static/media/Icon_Contact.0e379730.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_Contact.svg
// module id = 2311
// module chunks = 0